import { createFileRoute } from '@tanstack/react-router'
import { DidImportPage } from '@/features/admin/did-import'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/dids/import/')({
  component: DidImportPage,
  beforeLoad: requireRole(['admin']),
})
